// extracted by mini-css-extract-plugin
export default {"root":"VideoDisplay-module-root-msHJI","clear":"VideoDisplay-module-clear-lOA3l"};